import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { CustomUrlMapper } from './customUrlMapper'
import { CustomUrlMapperSymbol } from './symbols'
import { platformEnvDataProvider } from './platformEnvDataProvider'
import { PlatformEnvDataProviderSymbol } from '@wix/thunderbolt-symbols'

export { config } from './configs'

export const loader: ContainerModuleLoader = (bind) => {
	bind(CustomUrlMapperSymbol).to(CustomUrlMapper)
	bind(PlatformEnvDataProviderSymbol).to(platformEnvDataProvider)
}

export const site: ContainerModuleLoader = loader
export const editor: ContainerModuleLoader = loader

export * from './symbols'
export * from './types'
export { UrlMappingsKeys } from '@wix/url-mapper-utils'
